// Course management routes
import Courses from '../../views/Courses.vue'
import CourseDetails from '../../views/CourseDetails.vue'
import CreateCourse from '../../views/CreateCourse.vue'
import EditCourse from '../../views/EditCourse.vue'
import TreeViewCourses from '../../components/TreeViewCourses.vue'
import SleepingCoursesView from '../../views/SleepingCoursesView.vue'
import CourseMaker from '../../components/CourseMaker.vue'
import CourseLogistics from '../../components/CourseLogistics.vue'
import CourseUrls from '../../components/CourseUrls.vue'
import CourseCreationWizard from '../../components/CourseCreationWizard.vue'
import CourseCategories from '../../components/CourseCategories.vue'
import QuickCourseCreator from '../../components/QuickCourseCreator.vue'
import FullCourseBuilder from '../../components/FullCourseBuilder.vue'
import CourseGPT from '../../components/gpt/CourseGPT.vue'
import QuickEditView from '../../views/QuickEditView.vue'

export default [
  {
    path: '/courses',
    name: 'Courses',
    component: Courses,
    meta: { 
      requiresAuth: true,
      title: 'Course Management'
    }
  },
  {
    path: '/courses/:id',
    name: 'CourseDetails',
    component: CourseDetails,
    meta: { 
      requiresAuth: true,
      title: 'Course Details'
    }
  },
  {
    path: '/full-course-builder',
    name: 'FullCourseBuilder',
    component: FullCourseBuilder,
    meta: { 
      requiresAuth: true,
      title: 'Full Course Builder'
    }
  },
  {
    path: '/courses/:id/edit',
    name: 'EditCourse',
    component: EditCourse,
    meta: { 
      requiresAuth: true,
      title: 'Edit Course'
    }
  },
  {
    path: '/courses/create',
    name: 'CreateCourse',
    component: CreateCourse,
    meta: { 
      requiresAuth: true,
      title: 'Create New Course'
    }
  },
  {
    path: '/course-maker',
    name: 'CourseMaker',
    component: CourseMaker,
    meta: { 
      requiresAuth: true,
      title: 'Course Maker'
    }
  },
  {
    path: '/quick-course',
    name: 'QuickCourseCreator',
    component: QuickCourseCreator,
    meta: { 
      requiresAuth: true,
      title: 'Quick Course Creator'
    }
  },
  {
    path: '/course-logistics',
    name: 'CourseLogistics',
    component: CourseLogistics,
    meta: { 
      requiresAuth: true,
      title: 'Course Logistics'
    }
  },
  {
    path: '/course-urls',
    name: 'CourseUrls',
    component: CourseUrls,
    meta: { 
      requiresAuth: true,
      title: 'Course URLs'
    }
  },
  {
    path: '/course-creation-wizard',
    name: 'CourseCreationWizard',
    component: CourseCreationWizard,
    meta: { 
      requiresAuth: true,
      title: 'Course Creation Wizard'
    }
  },
  {
    path: '/course-categories',
    name: 'CourseCategories',
    component: CourseCategories,
    meta: { 
      requiresAuth: true,
      title: 'Course Categories'
    }
  },
  {
    path: '/course-gpt',
    name: 'CourseGPT',
    component: CourseGPT,
    meta: { 
      requiresAuth: true,
      title: 'AI Course Generator'
    }
  },
  {
    path: '/tree-view-courses',
    name: 'TreeViewCourses',
    component: TreeViewCourses,
    meta: { 
      requiresAuth: true,
      title: 'Course Tree View'
    }
  },
  {
    path: '/sleeping-courses',
    name: 'SleepingCourses',
    component: SleepingCoursesView,
    meta: { 
      requiresAuth: true,
      title: 'Inactive Courses'
    }
  },
  {
    path: '/quick-edit',
    name: 'QuickEdit',
    component: QuickEditView,
    meta: { 
      requiresAuth: true,
      title: 'Quick Edit'
    }
  }
] 